import oneClickAvatar from '../../assets/images/one-click-avatar.svg';
import policyAvatar from '../../assets/images/policy-avatar.svg';
import envCloneAvatar from '../../assets/images/env-clone-avatar.svg';
import deployAppAvatar from '../../assets/images/deploy-app-avatar.svg';
import workflowAvatar from '../../assets/images/workflow-avatar.svg';

const carouselContent = [
    {
        src: oneClickAvatar,
        title: "One Click Cluster",
        description: "Instantly create a cluster with just one click. Streamline your setup and launch your projects faster than ever before!",
        url: "https://docs.atmosly.com/clusters/one%20click%20cluster"
    },
    {
        src: deployAppAvatar,
        title: "Deploy Your Applications",
        description: "Seamlessly deploy your applications in minutes. Enjoy a smooth, hassle-free process that gets your projects up and running quickly.",
        url: "https://docs.atmosly.com/deploy-your-first-application"
    },
    {
        src: workflowAvatar,
        title: "Custom Workflow",
        description: "Design workflows tailored to your needs. Enhance efficiency and precision with a system built around your unique project requirements.",
        url: "https://docs.atmosly.com/workflows/about-workflows"
    },
    {
        src: envCloneAvatar,
        title: "Environment Cloning",
        description: "Rapidly clone environments to ensure consistency and speed up development. Perfect for replicating setups and accelerating your workflow.",
        url: "https://docs.atmosly.com/environments/cloning"
    },
    {
        src: policyAvatar,
        title: "Implement Policies via Guardrail",
        description: "Easily enforce organizational policies with Guardrail. Achieve seamless compliance and governance across all your deployments.",
        url: "https://docs.atmosly.com/Guardrails/Create-guardrails"
    }
]

export default carouselContent;